<template>
  <div>
    <h2 class="title">订单查询</h2>
    <el-form :inline="true" :model="orderForm" class="demo-form-inline">
      <div class="form_row_item">
        <el-form-item label="订单日期范围">
          <el-date-picker
            v-model="orderForm.orderDate"
            type="daterange"
            align="right"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd HH:mm"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearchOrder">查询</el-button>
          <el-button type="info" @click="onResetOrder">重置</el-button>
        </el-form-item>
      </div>
        
      <div class="form_row_item">
        <el-form-item label="按机构筛选">
          <el-select
            v-model="orderForm.orgName"
            :remote-method="onRemoteSearch"
            v-on:clear="onSearchClear"
            filterable clearable remote
            placeholder="按机构筛选">
            <el-option
              v-for="item in orgList"
              :key="item.orgId"
              :label="item.orgName"
              :value="item.orgName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="按类型筛选">
          <el-select
            v-model="orderForm.goodsType"
            placeholder="按类型筛选">
            <el-option
              v-for="item in types"
              :key="item.type"
              :label="item.name"
              :value="item.type"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="danger" @click="onBachExportOrder"><i class="el-icon-download"></i>导出所有订单</el-button>
        </el-form-item>
      </div>
    </el-form>

      <div class="result_table">
        <!-- <div class="result_table_title">
          <div class="org_name">三新文化传媒有限公司112221</div>
          <div class="total_prize">合计总价：<span class="num">￥2624.0</span></div>
          <div class="download_btn">
             <el-button type="success" round><i class="el-icon-download"></i>导出当前机构订单</el-button>
          </div>
        </div> -->
        <el-pagination
          background
          layout="sizes, prev, pager, next, jumper, ->, total"
          :total="totalOrderNum"
          :page-size="orderPageSize"
          :current-page="orderPageNow"
          v-on:size-change="onOrderSizeChange"
          v-on:current-change="onOrderCurrentChange"
          v-on:prev-click="onPrevClicked"
          v-on:next-click="onNextClicked"
          >
        </el-pagination>
        <el-table
          :data="orderList"
          stripe
          border
          style="width: 100%"
          :cell-style="onSetCellStyle"
          >
          <el-table-column
            prop="index"
            label="序列号"
            width="80">
          </el-table-column>
          <el-table-column
            prop="date"
            label="订单日期"
            width="180">
          </el-table-column>
          <el-table-column
            width="180"
            prop="customOrderId"
            label="订单编号">
          </el-table-column>
          <el-table-column
            prop="goodsTypeStr"
            width="80"
            label="订单类型">
          </el-table-column>
          <!-- <el-table-column
            width="80"
            prop=""
            label="订单册数">
          </el-table-column> -->
          <el-table-column
            prop="totalPrice"
            width="80"
            label="订单总价">
          </el-table-column>
          <el-table-column
            prop="userId"
            width="200"
            label="用户ID">
          </el-table-column>
          <el-table-column
            prop="userName"
            label="用户名">
          </el-table-column>
          <el-table-column
            prop=""
            label="操作">
            <template slot-scope="scope">
              <el-link type="primary" :href="getOrderDetailHref(scope.row)" target="_blank">查看详情</el-link>
              <el-link type="info" @click="onExportOrder(scope.row)" size="small">导出订单</el-link>
              <el-link type="info" @click="onExportMARC(scope.row)" size="small">导出MARC</el-link>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
        background
        layout="sizes, prev, pager, next, jumper, ->, total"
        :total="totalOrderNum"
        :page-size="orderPageSize"
        :current-page="orderPageNow"
        v-on:size-change="onOrderSizeChange"
        v-on:current-change="onOrderCurrentChange"
        v-on:prev-click="onPrevClicked"
        v-on:next-click="onNextClicked"
        >
      </el-pagination>
      </div>
  </div>
</template>

<script>
import { actionsearch } from '@/api/authority'
import { listManagerOrders, bachExportOrder } from '@/api/manager'
import { exportMarc, exportOrder } from '@/api/pages'
import Cookies from 'js-cookie'
import { toastSuccess } from '../../../common/utils/ui'
export default {
  data () {
    return {
      orderForm: {
        orderDate: '',
        orgName: '',
        goodsType: '' // 书籍类型
      },
      totalOrderNum: 0, // 订单总条数
      orderPageSize: 20,
      pageNum: 1,
      orderList: [], // 订单列表
      orgList: [], // 机构列表
      types: [
        {name: '纸质书', type: 1},
        {name: '电子书', type: 2},
        {name: '非书籍', type: 3}
      ],
      orderPageNow: 1,

      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      }
    }
  },

  created () {
    // 查询机构
    this.searchOrg()
    // 查询默认订单
    this.queryOrders()
  },

  methods: {
    searchOrg (orgName) {
      return new Promise(resolve => {
        const param = {
          orgType: 1,
          orgName
        }
        actionsearch(param).then(ret => {
          const list = (ret.result || []).map(item => {
            return {
              orgId: item.gid,
              orgName: item.orgName,
              orgCode: item.orgCode
            }
          })

          this.orgList = list
          resolve()
        })
      })
    },

    onRemoteSearch (searchStr) {
      this.__searchTimer && clearTimeout(this.__searchTimer)
      this.__searchTimer = setTimeout(() => {
        this.searchOrg(searchStr)
      }, 200)
    },

    onSearchClear () {
      this.onRemoteSearch('')
    },

    onResetOrder () {
      this.orderForm.orgName = ''
      this.orderForm.orderDate = []
      this.orderForm.goodsType = ''
      this.orderPageNow = 1

      this.queryOrders()
    },

    // 查询订单
    queryOrders () {
      const orgName = this.orderForm.orgName
      const startTime = this.orderForm.orderDate[0]
      const endTime = this.orderForm.orderDate[1]
      const goodsType = this.orderForm.goodsType
      const param = {
        pageNum: this.orderPageNow,
        pageSize: this.orderPageSize,
        // userName: "demoData",
        orgName,
        startTime,
        endTime,
        goodsType
      }
      listManagerOrders(param).then(ret => {
        const data = ret.data || {}
        this.totalOrderNum = data.total
        const list = (data.list || []).map((item, index) => {
          const goodsTypeStr = (this.types.filter(typeItem => {
            return typeItem.type === item.goodsType
          })[0] || {}).name || '暂无'

          return {
            index: index + 1,
            date: item.createTime,
            customOrderId: item.customOrderId,
            orderId: item.orderId,
            goodsTypeStr,
            totalPrice: '¥' + item.totalPrice,
            userId: item.userId,
            userName: item.remark
          }
        })
        this.orderList = list
      })
    },

    onSearchOrder () {
      this.orderPageNow = 1
      this.queryOrders()
    },

    onOrderSizeChange (size) {
      this.orderPageSize = size
      this.queryOrders()
    },

    onOrderCurrentChange (orderPageNow) {
      this.orderPageNow = orderPageNow
      this.queryOrders()
    },

    onPrevClicked (orderPageNow) {
      this.orderPageNow = orderPageNow
      this.queryOrders()
    },

    onNextClicked (orderPageNow) {
      this.orderPageNow = orderPageNow
      this.queryOrders()
    },

    // 查看详情
    getOrderDetailHref (rowData) {
      const routeJump = this.$router.resolve({ name: 'OrderDetail', query: { orderId: rowData.orderId } })
      return routeJump.href
    },

    // 导出订单
    onExportOrder (rowData) {
      const param = {
        orderId: rowData.orderId,
        userName: Cookies.get('name')
      }
      exportOrder(param).then(response => {
        window.location.href = response.data
        toastSuccess('订单导出成功')
      })
    },

    onExportMARC (rowData) {
      const param = {
        orderId: rowData.orderId,
        userName: Cookies.get('name')
      }
      exportMarc(param).then(ret => {
        window.location.href = ret.data
        toastSuccess('MARC导出成功')
      })
    },

    // 批量导出订单
    onBachExportOrder () {
      const orgName = this.orderForm.orgName
      const startTime = this.orderForm.orderDate[0]
      const endTime = this.orderForm.orderDate[1]
      const goodsType = this.orderForm.goodsType
      const param = {
        pageNum: this.orderPageNow,
        pageSize: this.orderPageSize,
        orgName,
        startTime,
        endTime,
        goodsType
      }

      bachExportOrder(param).then(ret => {
        window.location.href = ret.data
        toastSuccess('所有订单导出成功')
      })
    },

    onSetCellStyle (cellInfo) {
      if (cellInfo.column.property === 'totalPrice') {
        return {
          color: '#F70606'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .demo-form-inline {
    border: 1px solid #e6e6e6;
    padding: 15px 10px 0 10px;
    border-radius: 4px;
  }
  .title {
    line-height: 40px;
    border-bottom: 1px solid #e6e6e6;
    margin-bottom: 20px;
  }
  .result_table {
    margin-top: 20px;
  }
  .result_table .el-pagination {
    text-align: right;
    margin: 10px;
  }
  .result_table_title {
    display: flex;
    background: rgba(242, 242, 242, 1);
    padding: 5px 10px;
    justify-content: center;
    align-items: center;
    color: #666666;
  }
  .result_table_title >div{
    flex: 1;
  }

  .result_table_title .download_btn {
    text-align: right;
  }
  .result_table_title .total_prize{
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// src/views/SysManager/Order/index.vue